import { flexRender, type Row } from '@tanstack/react-table'
import type { Driver } from '../../../../../types'
import TableMobileCardContent from '../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'

export const MobileCardData = ({ row }: { row: Row<Driver> }) => {
  const getCellById = (id: string) => row.getVisibleCells().find((info) => info.column.id === id)

  const renderCellValue = (id: string) => {
    const cell = getCellById(id)
    if (!cell) return '-'
    return flexRender(cell.column.columnDef.cell, cell.getContext())
  }

  const header = renderCellValue('name')

  const data = [
    { label: 'Stilling', value: renderCellValue('jobTitle') },
    { label: 'Telefon', value: renderCellValue('phoneNo') },
    { label: 'E-post', value: renderCellValue('email') },
    { label: 'Konfig tilgang', value: renderCellValue('hasConfiguratorAccess') },
    { label: 'Kundetilgang', value: renderCellValue('webTilgang') },
  ]

  const actions = renderCellValue('actions')

  return <TableMobileCardContent header={header} data={data} action={{ type: 'custom', item: actions }} />
}
